import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Grid, Box, Typography } from "@mui/material"
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import axios from 'axios';
import Basics from './Basics';
import AddEducationDetails from './AddEducationDetails';
import AddExperianceDetail from './AddExperianceDetail';
import Document from './Document';
import BankDetails from './BankDetails';
import PersonalInformation from './PersonalInformation';
import { makeApiRequest } from '../../../utils/api';
import { useLocation, useNavigate } from 'react-router-dom';



export const AddTeamMembers = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { editMode, formData: existingData } = location.state || {};
    const [value, setValue] = useState('Basics');
    const [formData, setFormData] = useState(editMode ? existingData : {
        basic: {
            emp_code: '',
            name: '',
            name2: '',
            phoneno: '',
            mode: '',
        },
        personal: {
            official_email: '',
            marital_status: '',
        },
        documents: {},
        education: {
            sslc: {},
            hlc: {},
            diploma: {},
            bachelor: {},
            master: {}
        },
        experience: {
            prof_ref: {}
        },
        bank_details: {},
        emergency_contact: {}
    });

    const handleFormDataChange = (section, updatedData) => {
        setFormData((prev) => ({
            ...prev,
            [section]: {
                ...prev[section],
                ...updatedData,
            },
        }));
    };
    const handleSubmit = async () => {
        try {
            const username = formData.basic?.username || '';
            if (!username.trim()) {
                toast.warn("Username is required.");
                return;
            }
            const token = localStorage.getItem('authToken');
            const requestData = {
                token: token,
                data: {
                    basic: {
                        ...formData.basic,
                        addr: formData.basic?.addr || '',
                        paddr: formData.basic?.paddr || '',
                        emp_code: formData.basic?.username || '',
                        name: formData.basic?.name || '',
                        name2: formData.basic?.name2 || '',
                        phoneno: formData.basic?.phoneno || '',
                        location: formData.basic?.location || '',
                        emp_type: formData.basic?.emp_type || '',
                        control:formData.basic?.emp_type || '',
                        etype: formData.basic?.etype || '',
                        org_doj: formData.basic?.org_doj || '',
                        conserv_exp: formData.basic?.conserv_exp || '',
                        estatus: formData.basic?.estatus || 'Active',
                        reportto: formData.basic?.reportto || '',
                        shift: formData.basic?.shift || '',
                        batch_id: formData.basic?.batch_id || '',
                        department: formData.basic?.department || '',
                        course_id: formData.basic?.course_id || '',
                    },
                    personal: {
                        ...formData.personal,
                        dob_in_cert: formData.personal?.dob_in_cert || '',
                        dob_org: formData.personal?.dob_org || '',
                        marital_status: formData.personal?.marital_status || '',
                        father_spouse_name: formData.personal?.father_spouse_name || '',
                        official_email: formData.personal?.official_email || '',
                        personal_email: formData.personal?.personal_email || '',
                        alt_phone: formData.personal?.alt_phone || '',
                        nationality: formData.personal?.nationality || '',
                        bg: formData.personal?.bg || '',
                        image: formData.personal?.image || '',
                    },
                    documents: formData.documents || {},
                    education: {
                        sslc: {
                            institution: formData.education?.sslc?.institution || '',
                            department: formData.education?.sslc?.department || '',
                            perc: formData.education?.sslc?.perc || '',
                            year_of_passing: formData.education?.sslc?.year_of_passing || '',
                            file: formData.education?.sslc?.file || ''
                        },
                        hlc: {
                            institution: formData.education?.hlc?.institution || '',
                            department: formData.education?.hlc?.department || '',
                            perc: formData.education?.hlc?.perc || '',
                            year_of_passing: formData.education?.hlc?.year_of_passing || '',
                            file: formData.education?.hlc?.file || ''
                        },
                        diploma: {
                            institution: formData.education?.diploma?.institution || '',
                            department: formData.education?.diploma?.department || '',
                            perc: formData.education?.diploma?.perc || '',
                            year_of_passing: formData.education?.diploma?.year_of_passing || '',
                            file: formData.education?.diploma?.file || ''
                        },
                        bachelor: {
                            institution: formData.education?.bachelor?.institution || '',
                            department: formData.education?.bachelor?.department || '',
                            perc: formData.education?.bachelor?.perc || '',
                            year_of_passing: formData.education?.bachelor?.year_of_passing || '',
                            file: formData.education?.bachelor?.file || ''
                        },
                        master: {
                            institution: formData.education?.master?.institution || '',
                            department: formData.education?.master?.department || '',
                            perc: formData.education?.master?.perc || '',
                            year_of_passing: formData.education?.master?.year_of_passing || '',
                            file: formData.education?.master?.file || ''
                        }
                    },
                    experience: formData.experience || {},
                    bank_details: formData.bank_details || {},
                    emergency_contact: formData.emergency_contact || {},
                    name: `${formData.basic?.name || ''} ${formData.basic?.name2 || ''}`.trim(),
                    email: formData.personal?.official_email || '',
                    mobile_num: formData.basic?.phoneno || '',
                    addr: formData.basic?.residential_address || '',
                    location: formData.basic?.location || ''
                }
            };

            if (editMode) {
                requestData.data.id = formData.basic?.username || '';
            }

            const control = localStorage.getItem('control');
            if (editMode && formData.basic?.emp_type === "3" && (control == 1 || control == 4)) {
                const editRequestPayload = {
                    token: token,
                    module: 'student_profile',
                    reference_id: formData.basic?.id,
                    old_data: existingData,
                    new_data: requestData.data
                };
                const response = await makeApiRequest('post', '/api/edit-requests/save', editRequestPayload, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                if (response && response.status === 'success') {
                    toast.success("Edit request submitted successfully and is pending admin approval.");
                    alert("Edit request submitted successfully and is pending admin approval.");
                    navigate(-1);
                } else {
                    toast.error(response?.message || "Failed to submit edit request");
                }
                return;
            }

            const endpoint = !editMode ? '/api/employee/save' : '/api/employee/update';

            const response = await makeApiRequest('post', endpoint, requestData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if(response.status === "success"){
                toast.info(response.message);
                alert(response.message);
            }

            if (editMode) {
                navigate(-1);
            } else {
                setFormData({
                    basic: {
                        username: '',
                        addr: '',
                        paddr: '',
                        name: '',
                        name2: '',
                        phoneno: '',
                        location: '',
                        emp_type: '',
                        etype: '',
                        org_doj: '',
                        conserv_exp: '',
                        estatus: 'active',
                        reportto: '',
                        shift: '',
                        batch_id: '',
                        department: '',
                        course_id: '',
                        mode: '',
                    },
                    personal: {
                        dob_in_cert: '',
                        dob_org: '',
                        marital_status: '',
                        father_spouse_name: '',
                        official_email: '',
                        personal_email: '',
                        alternate_contact_no: '',
                        nationality: '',
                        bg: '',
                        image: '',
                    },
                    documents: {},
                    education: {
                        sslc: { institution: '', department: '', perc: '', year_of_passing: '', file: '' },
                        hlc: { institution: '', department: '', perc: '', year_of_passing: '', file: '' },
                        diploma: { institution: '', department: '', perc: '', year_of_passing: '', file: '' },
                        bachelor: { institution: '', department: '', perc: '', year_of_passing: '', file: '' },
                        master: { institution: '', department: '', perc: '', year_of_passing: '', file: '' }
                    },
                    experience: {},
                    bank_details: {},
                    emergency_contact: {}
                });
                setValue('Basics');
            }
        } catch (error) {
            console.error('Error saving employee:', error.response?.data || error.message);
            const errMsg = error.response?.data?.message || "Error saving data. Please try again.";
            toast.error(errMsg);
        }
    };

    const tabs = [
        { value: 'Basics', label: 'Basics' },
        { value: 'Personal Information', label: 'Personal Information' },
        { value: 'Document', label: 'Document' },
        { value: 'Education', label: 'Education' },
        { value: 'Experience', label: 'Experience' },
        { value: 'Bank Details', label: 'Bank Details' }
    ];

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const componentProps = {
        formData,
        handleFormDataChange,
        handleSubmit,
        setValue
    };

    const componentMap = {
        'Basics': <Basics {...componentProps} />,
        'Personal Information': <PersonalInformation {...componentProps} />,
        'Document': <Document {...componentProps} />,
        'Education': <AddEducationDetails {...componentProps} />,
        'Experience': <AddExperianceDetail {...componentProps} />,
        'Bank Details': <BankDetails {...componentProps} />
    };

    return (
        <Box sx={{ backgroundColor: "#ECEDFF", minHeight: '100vh' }}>
             <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
            <Grid container sx={{ backgroundColor: "#ECEDFF", height: "auto", width: "100%", display: "flex", justifyContent: "center", }}>
                <Grid item xs={11} sx={{ height: "80px", width: "100%", backgroundColor: "#ECEDFF", display: "flex", alignItems: "center" }}>
                    <Typography variant='h4' sx={{ color: "#481E82", fontSize: { xs: '24px', sm: '34px' } }}>Add Team Member</Typography>
                </Grid>
                <Grid item xs={11}>
                    <Grid container>
                        <Grid item xs={12} sx={{ height: "100px",borderRadius: "5px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Box sx={{ width: '100%', display: "flex", justifyContent: "center" }}>
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    // textColor="secondary"
                                    // indicatorColor="primary"
                                    aria-label="secondary tabs example"
                                    variant="scrollable" // Enables scrolling
                                    scrollButtons="auto"
                                >
                                    {tabs.map((tab) => (
                                        <Tab
                                            key={tab.value}
                                            value={tab.value}
                                            label={tab.label}
                                            sx={{ fontSize: '16px' }}
                                        />
                                    ))}
                                </Tabs>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sx={{ height: "auto", backgroundColor: "white" }}>
                            {componentMap[value]}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}